// extracted by mini-css-extract-plugin
export var link = "hw_P";